import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes, { number } from 'prop-types';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import _ from 'underscore';
import validate from 'validate.js';
import uuid from 'uuid/v1';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Card,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
	Tooltip,
	Divider,
	CardActions,
	CardContent,
	colors,
	Grid,
	Button,
	TextField
} from '@mui/material';
import DatePicker from 'components/DatePicker/DatePicker.js';
import { SelectField } from 'components';
import { SetFormState, GenerateReport } from '../../actions/ReportsKpisActions';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(2),
	},
	value: {
		fontWeight: theme.typography.fontWeightMedium,
		align: 'center'
	},
	type: {
		fontWeight: theme.typography.fontWeightMedium,
	},
	warning: {
		color: colors.orange[500]
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const ClusterInfo = (props) => {
	const { className, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.reportsKpisRanReducer.formState);
	const userId = useSelector((state) => state.session.user.id);
	const clustersNames = useSelector((state) => state.reportsKpisRanReducer.clustersNames);

	const _generate = () => {
		dispatch(GenerateReport(
			userId, formState.values.clusterName, formState.values.preStartDate, formState.values.preEndDate,
			formState.values.postStartDate, formState.values.postEndDate
		));
		dispatch(enqueueSnackbar({ message: 'Report Sent to Queue', options: { variant: 'info' } }));
	};

	const _handleDateChange = (value, name, type = 'date') => {
		let formattedValue = null;

		if (value) {
			if (type === 'date') {
				formattedValue = value.startOf('day').format('YYYY-MM-DD');
			} else {
				formattedValue = value.format('YYYY-MM-DD HH:mm:ss');
			}
		}

		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: formattedValue
			},
			touched: {
				...formState.touched,
				[name]: true
			}
		});
	};

	const [errorState, setErrorState] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const _handleChange = event => {

		setErrorState(false);
		setErrorMessage('');

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<List>
				<ListItem
					key={1}
				>
					<Grid container spacing={1}>
						<Grid item md={2} xs={2}>
							<DatePicker
								id="preStartDate"
								name="preStartDate"
								label="Pre StartDate"
								value={formState.values.preStartDate}
								onChange={value => _handleDateChange(value, 'preStartDate', 'date')}
								format="DD/MM/YYYY"
							/>
						</Grid>
						<Grid item md={2} xs={2}>
							<DatePicker
								id="preEndDate"
								name="preEndDate"
								label="Pre EndDate"
								value={formState.values.preEndDate}
								onChange={value => _handleDateChange(value, 'preEndDate', 'date')}
								format="DD/MM/YYYY"
							/>
						</Grid>
						<Grid item md={2} xs={2}>
							<DatePicker
								id="postStartDate"
								name="postStartDate"
								label="Pre StartDate"
								value={formState.values.postStartDate}
								onChange={value => _handleDateChange(value, 'postStartDate', 'date')}
								format="DD/MM/YYYY"
							/>
						</Grid>
						<Grid item md={2} xs={2}>
							<DatePicker
								id="postEndDate"
								name="postEndDate"
								label="Pre EndDate"
								value={formState.values.postEndDate}
								onChange={value => _handleDateChange(value, 'postEndDate', 'date')}
								format="DD/MM/YYYY"
							/>
						</Grid>
					</Grid>
				</ListItem>
			</List>
			<Divider />
			<CardActions>
				<Button
					className={classes.generate}
					onClick={_generate}
					variant="contained"
					disabled={
						   formState.values.preStartDate === undefined
						|| formState.values.preEndDate === undefined
						|| formState.values.postStartDate === undefined
						|| formState.values.postEndDate === undefined
					}
				>
					Generate
				</Button>
			</CardActions>
		</Card >
	);
};

ClusterInfo.propTypes = {
	className: PropTypes.string
};

export default ClusterInfo;
